"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryIconByCountryCode = exports.getCountryKeyByCountryCode = exports.getCountryCodeByCountryName = exports.getCountryNameByCountryCode = void 0;
var locale_1 = require("../locale");
var getObjectKeys_1 = require("./getObjectKeys");
var isKeyInObject_1 = require("./isKeyInObject");
var T = {
    UNKNOWN: function (input) { return "unknown country ".concat(input); },
};
/**
 * Helper to get the `countryName` of a country by providing the `countryCode`.
 *
 * @example
 * // returns 'Deutschland'
 *  getCountryN ameByCountryCode('DE')
 *
 * @param countryCode
 */
// TODO: change this helperFunction to use the regionObject
var getCountryNameByCountryCode = function (countryCode) {
    var countryKey = Object.keys(locale_1.allCountries).find(function (country) {
        return (0, isKeyInObject_1.isKeyInObject)(locale_1.allCountries, country)
            ? locale_1.allCountries[country].countryCode === countryCode
            : false;
    });
    return countryKey && (0, isKeyInObject_1.isKeyInObject)(locale_1.allCountries, countryKey)
        ? locale_1.allCountries[countryKey].countryName
        : T.UNKNOWN(countryCode);
};
exports.getCountryNameByCountryCode = getCountryNameByCountryCode;
/**
 * Helper to get the `countryKey`-like value of a country by providing the `countryCode`, the first letter of the `countryKey` is uppercased
 *
 * @example
 * // returns 'Germany'
 *  getCountry KeyByCountryCode('DE')
 *
 * @param countryCode
 */
var getCountryKeyByCountryCode = function (countryCode) {
    var countryKey = Object.keys(locale_1.allCountries).find(function (country) {
        return (0, isKeyInObject_1.isKeyInObject)(locale_1.allCountries, country)
            ? locale_1.allCountries[country].countryCode === countryCode
            : false;
    });
    return countryKey && (0, isKeyInObject_1.isKeyInObject)(locale_1.allCountries, countryKey)
        ? "".concat(countryKey[0].toUpperCase()).concat(countryKey.slice(1))
        : T.UNKNOWN(countryCode);
};
exports.getCountryKeyByCountryCode = getCountryKeyByCountryCode;
/**
 * Helper to get the `countryCode` of a country by providing the `countryName`.
 *
 * @example
 * // returns 'DE'
 *  getCountryNameByCountryCode('Deutschland')
 *
 * @param countryCode
 */
var getCountryCodeByCountryName = function (countryName) {
    var countryKey = Object.keys(locale_1.allCountries).find(function (country) {
        return (0, isKeyInObject_1.isKeyInObject)(locale_1.allCountries, country)
            ? locale_1.allCountries[country].countryName === countryName
            : false;
    });
    return countryKey && (0, isKeyInObject_1.isKeyInObject)(locale_1.allCountries, countryKey)
        ? locale_1.allCountries[countryKey].countryCode
        : T.UNKNOWN(countryName);
};
exports.getCountryCodeByCountryName = getCountryCodeByCountryName;
/**
 * Helper to get the `countryIcon` (flag symbol) of a country by providing the `countryCode`.
 *
 * @example
 * // returns '🇩🇪'
 *  getCountryIconByCountryCode('DE')
 *
 * @param countryCode
 */
var getCountryIconByCountryCode = function (countryCode) {
    var countryObject = (0, getObjectKeys_1.getObjectKeys)(locale_1.allCountries)
        .map(function (countryKey) { return locale_1.allCountries[countryKey]; })
        .find(function (country) { return country.countryCode === countryCode; });
    return countryObject ? countryObject.icon : '🏴‍☠️';
};
exports.getCountryIconByCountryCode = getCountryIconByCountryCode;
